import { useAuth } from '@/contexts/AuthContext';
import type { Equipamento } from '../../../../models';
import { useEquipamentoMutations } from '../../../../hooks/data';
import { MOTIVO_EXCLUSAO_ATIVO_LABELS } from './ativos.utils';

/** Topo da ficha de um ativo excluído: motivo/quem/quando + Restaurar (o resto fica só pra consulta). */
export default function AtivoExcluidoFaixa({ equipamento }: { equipamento: Equipamento }) {
  const { user } = useAuth();
  const { restaurarAtivo } = useEquipamentoMutations();
  const quando = equipamento.excluidoEm?.toDate().toLocaleDateString('pt-BR');
  const motivo = [
    equipamento.motivoExclusaoTipo ? MOTIVO_EXCLUSAO_ATIVO_LABELS[equipamento.motivoExclusaoTipo] : null,
    equipamento.motivoExclusao,
  ]
    .filter(Boolean)
    .join(' — ');

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-gray-300 bg-gray-100 p-3 text-sm">
      <div>
        <p className="font-semibold text-gray-800">Ativo excluído — só consulta</p>
        <p className="text-xs text-gray-600">
          {motivo || 'Sem motivo registrado'}
          {equipamento.excluidoPor?.name ? ` · por ${equipamento.excluidoPor.name}` : ''}
          {quando ? ` em ${quando}` : ''}
        </p>
      </div>
      <button
        type="button"
        className="btn-secondary ml-auto text-sm"
        disabled={!user || restaurarAtivo.isPending}
        onClick={() =>
          user &&
          restaurarAtivo.mutate({
            id: equipamento.id,
            ator: { id: user.collaboratorId ?? user.uid, name: user.displayName ?? user.email ?? '', avatar: null },
          })
        }
      >
        {restaurarAtivo.isPending ? 'Restaurando...' : 'Restaurar'}
      </button>
    </div>
  );
}
